<template>
    <div :class="tagClass" class="inline-flex justify-center items-center">
        <slot name="front-icon"></slot>
        <!-- <template v-slot:front-icon></template> -->
        <span class="">
            {{ displayTagText }}
        </span>
        <slot name="back-icon"></slot>
    </div>
</template>

<script>
    export default {
        emits: [],
        props: {
            // tagPresetMap 에 등록하고 재사용 
            tagName : { type : String, required : false }, // FILING, LEAVES, ATTENDANCE 
            // SUBTLE, SOLID == PRIMARY, OUTLINE
            tagType: { type: String, default: 'SUBTLE', required: false },
            // M, S
            tagSize: { type: String, default: 'M', required: false },
            // GREY, RED, GREEN, BLUE, ORANGE, VIOLET
            tagColor: { type: String, default: 'GREY', required: false },
            tagText: { type: String, default: null, required: false },
        },
        data() {
            return {
                // Preset tag styles keyed by tagName for quick reuse
                tagPresetMap: {
                    RESIGNED : { tagType: 'SUBTLE', tagSize: 'S', tagColor: 'RED' },
                    ATTENDANCE: { tagType: 'SUBTLE', tagSize: 'S', tagColor: 'VIOLET' },
                    LEAVE: { tagType: 'SUBTLE', tagSize: 'S', tagColor: 'GREEN' },
                    FILING: { tagType: 'SUBTLE', tagSize: 'S', tagColor: 'ORANGE' },
                    VERIFIED: { tagType: 'SUBTLE', tagSize: 'S', tagColor: 'GREEN' },
                },
                sizeMap: {
                    L: 'h-8 p-2 gap-1 text-[0.75rem] leading-normal font-semibold rounded-02',
                    M: 'h-8 p-2 gap-1 text-[0.75rem] leading-normal font-semibold rounded-02',
                    S: 'h-6 p-1 gap-1 text-[0.6875rem] font-medium leading-normal rounded-01_5',
                },
                colorVariantStyle : {
                    GREY : {
                        SOLID : 'bg-background-inverse-1 text-content-inverse-1',
                        SUBTLE : 'bg-background-basic-4 text-content-basic-1',
                        LINE : 'text-content-basic-1 border border-border-basic-2 bg-background-basic-1'
                    },
                    RED : {
                        SOLID  : 'bg-accent-red-3 text-content-inverse-1',
                        SUBTLE : 'bg-accent-red-1 text-accent-red-3',
                        LINE   : 'bg-background-basic-1 border border-accent-red-3 text-accent-red-3',
                    },
                    GREEN : {
                        SOLID  : 'bg-accent-green-3 text-content-inverse-1',
                        SUBTLE : 'bg-accent-green-1 text-accent-green-3',
                        LINE   : 'bg-background-basic-1 border border-accent-green-3 text-accent-green-3',
                    },
                    BLUE : {
                        SOLID  : 'bg-accent-blue-3 text-content-inverse-1',
                        SUBTLE : 'bg-accent-blue-1 text-accent-blue-3',
                        LINE   : 'bg-background-basic-1 border border-accent-blue-3 text-accent-blue-3',
                    },
                    ORANGE : {
                        SOLID  : 'bg-accent-yellow-3 text-content-inverse-1',
                        SUBTLE : 'bg-accent-yellow-1 text-accent-yellow-3',
                        LINE   : 'bg-background-basic-1 border border-accent-yellow-3 text-accent-yellow-3',
                    },
                    VIOLET : {
                        SOLID  : 'bg-accent-violet-3 text-content-inverse-1',
                        SUBTLE : 'bg-accent-violet-1 text-accent-violet-3',
                        LINE   : 'bg-background-basic-1 border border-accent-violet-3 text-accent-violet-3',
                    },
                },
            };
        },
        computed: {
            resolvedTagProps() {
                const fallback = {
                    tagType: this.tagType,
                    tagSize: this.tagSize,
                    tagColor: this.tagColor,
                    tagText: this.tagText,
                };

                if (!this.tagName) {
                    return fallback;
                }

                const name = this.tagName.toUpperCase();
                const preset = this.tagPresetMap[name];
                const tagText = this.toTitleFromSnake(name);

                if (!preset) {
                    return {
                        ...fallback,
                        tagText: this.tagText || tagText,
                    };
                }

                return {
                    tagType: preset.tagType || fallback.tagType,
                    tagSize: preset.tagSize || fallback.tagSize,
                    tagColor: preset.tagColor || fallback.tagColor,
                    // 우선순위: 전달된 tagText > 프리셋 텍스트 > tagName camel
                    tagText: this.tagText ?? preset.tagText ?? tagText,
                };
            },
            tagClass() {
                const sizeClass = this.sizeMap[this.resolvedTagProps.tagSize.toUpperCase()] || '';
                
                const type = this.resolvedTagProps.tagType.toUpperCase();
                const colorType = this.resolvedTagProps.tagColor.toUpperCase();
                const colorClass = this.getStyleByType(colorType, type)

                return [sizeClass, colorClass].join(' ');
            },
            displayTagText() {
                return this.resolvedTagProps.tagText;
            },
            
        },
        methods: {
            getStyleByType(color, type) {
                const colorConfig = this.colorVariantStyle[color];
                if (colorConfig && colorConfig[type]) {
                    return colorConfig[type];
                }

                return '';
            },
            toTitleFromSnake(input) {
                if (!input) return '';
                return input
                    .toLowerCase()
                    .split('_')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
            }
        },
    };
</script>
